module.exports = __webpack_public_path__ + "img/logo2.1dd38d75.png";